(function ($) {
  Drupal.behaviors.beautiful_belle_hero = {
    attach: function (context) {
      $('#belle_mod1', context).once(function () {
        var thisModuleName = 'belle_mod1';
        var triggerMod = '#belle_mod1';
        var $thismodule = $('#belle_mod1');
        // If module is called in URL, scroll to module.
        var urlHash = window.location.href.split('#')[1];

        if (urlHash === thisModuleName) {
          $('html,body').animate(
            {
              scrollTop: $thismodule.offset().top - 85
            },
            1500
          );
        }

        // Check if Content Author has specified for module
        // to fade in.
        var moduleWillFade = false;
        var hasFaded = false;

        if ($thismodule.data('scrollmagic') === 1) {
          moduleWillFade = true;
        }

        // Hide and push down the module if it is to be faded in.
        if (moduleWillFade) {
          $thismodule.addClass('hideModules');
        }

        // Handle module fade-in from CMS.
        function fadeThisModule() {
          if (hasFaded === false) {
            hasFaded = true;
            $thismodule.animate(
              {
                opacity: 1,
                paddingTop: '0'
              },
              350,
              'easeOutQuad'
            );
          } else {
            return;
          }
        }

        $(window).on('load', function () {
          // Handle the hero text fade-in
          $(
            '.js-belle__hero-block_1, .js-belle__hero-block_2, .js-belle__hero-block_3, .js-belle__hero-block_4'
          ).animate(
            {
              opacity: '0'
            },
            0
          );
          $('.js-belle__hero-block_1').delay(250).animate(
            {
              opacity: 1,
              top: '24%'
            },
            500
          );
          $('.js-belle__hero-block_2').delay(450).animate(
            {
              opacity: 1,
              top: '0'
            },
            500
          );
          $('.js-belle__hero-block_3').delay(650).animate(
            {
              opacity: 1,
              top: '48.8%'
            },
            500
          );
          $('.js-belle__hero-block_4').delay(850).animate(
            {
              opacity: 1,
              top: '51.9%'
            },
            500
          );

          // Content-Author-managed - Module Fade.
          if (moduleWillFade) {
            // Put in window load so that the page height is ready
            // by the time we get to animating.

            // Init scrollMagic Controller Class
            var controller = new ScrollMagic.Controller();
            var offset;

            // Set the offset.
            if ($thismodule.data('offset')) {
              offset = $thismodule.data('offset');
            } else {
              offset = 0;
            }

            // Init scrollMagic Scene Class
            var fadeThisModuleScene = new ScrollMagic.Scene({
              triggerElement: triggerMod,
              offset: offset
            }).on('start', function () {
              fadeThisModule();
            });

            controller.addScene([fadeThisModuleScene]);
          }
        });
      });
    }
  };
})(jQuery);
